import TIMELINE_WORDINGS from './wording.js';

const TimelineWordingMixin = {
    methods: {
        getWording(wordingKey, subs) {
            const wording = TIMELINE_WORDINGS[wordingKey];

            if (!wording) {
                throw `The wording for ${wordingKey} does not exist`;
            }
            return wording(subs);
        },
    },
};

export default TimelineWordingMixin;
